import { Link, useNavigate } from 'react-router-dom';

type Props = {
  slug: string;
  active: 'stickers' | 'friends';
};

export function AlbumTabs({ slug, active }: Props) {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-20 bg-bg safe-top">
      <div className="px-3 pt-2 pb-1 flex items-center gap-2">
        <button
          type="button"
          onClick={() => navigate('/albums')}
          className="p-2 -ml-2 text-muted text-lg"
          aria-label="Zurück zu Alben"
        >
          ←
        </button>
        <div className="flex-1">
          <p className="font-mono text-[10px] tracking-[.08em] text-muted leading-none">
            {slug.toUpperCase()}
          </p>
        </div>
        <Link
          to="/me"
          className="font-mono text-[10px] tracking-[.08em] text-muted px-2 py-1"
        >
          PROFIL
        </Link>
      </div>
      <nav className="flex border-b border-border/60 px-3">
        <TabLink to={`/albums/${slug}`} active={active === 'stickers'}>Sticker</TabLink>
        <TabLink to={`/albums/${slug}/friends`} active={active === 'friends'}>Tausch</TabLink>
      </nav>
    </header>
  );
}

function TabLink({
  to,
  active,
  children,
}: {
  to: string;
  active: boolean;
  children: React.ReactNode;
}) {
  return (
    <Link
      to={to}
      className={`flex-1 py-3 text-center font-sans font-bold text-sm ${
        active ? 'text-text border-b-2 border-primary -mb-px' : 'text-muted'
      }`}
    >
      {children}
    </Link>
  );
}
